module.exports = __webpack_public_path__ + "images/emails/signatures/liz-29adefcedeac565963c6eac3aaf677bd.jpg";